/**
 * Renames the "Checkout" / "View cart" button labels inside the side cart
 * panel rendered by the Boost AI Search & Filter app (classes
 * `boost-sd__btn-checkout` / `boost-sd__btn-view-cart`) to Spanish.
 *
 * Boost's own app settings (Settings > Translation) do not expose a way to
 * translate these two specific labels — they ship hardcoded in English
 * regardless of the store's language. This does not touch Boost's app, the
 * cart/checkout logic, or Dawn's own cart drawer/notification (which are
 * already correctly translated via the theme's locale files) — it only
 * renames the visible text of these two buttons wherever Boost renders them.
 *
 * Boost re-renders its side cart panel on every change (quantity update,
 * item removed, item added) in more than one step, so a MutationObserver
 * keeps watching and re-applies the labels immediately and again after two
 * short delays, to catch a late overwrite from Boost's own re-render.
 */
(function () {
  var LABELS = [
    { selector: '.boost-sd__btn-checkout', text: 'Pagar' },
    { selector: '.boost-sd__btn-view-cart', text: 'Ver carrito' },
  ];

  function applyLabels() {
    LABELS.forEach(function (item) {
      document.querySelectorAll(item.selector).forEach(function (btn) {
        if (btn.textContent.trim() !== item.text) {
          btn.textContent = item.text;
        }
      });
    });
  }

  applyLabels();

  // Boost re-renders the cart panel in more than one step after actions
  // like a quantity change (it redraws the item list, then separately
  // resets the button text from its own English defaults a moment later).
  // A single immediate re-apply loses that race, so every mutation batch
  // re-applies right away AND again after two short delays to catch a
  // late overwrite from Boost's own re-render finishing.
  var settleTimer = null;
  var lateTimer = null;

  function scheduleApply() {
    applyLabels();
    clearTimeout(settleTimer);
    settleTimer = setTimeout(applyLabels, 150);
    clearTimeout(lateTimer);
    lateTimer = setTimeout(applyLabels, 600);
  }

  new MutationObserver(scheduleApply).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
